import { render } from "./KeyboardBackspace.vue?vue&type=template&id=2805488c"
import script from "./KeyboardBackspace.vue?vue&type=script&lang=js"
export * from "./KeyboardBackspace.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardBackspace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2805488c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2805488c', __exports__)) {
    api.reload('2805488c', __exports__)
  }
  
  module.hot.accept("./KeyboardBackspace.vue?vue&type=template&id=2805488c", () => {
    api.rerender('2805488c', render)
  })

}


export default __exports__